import { useState, useEffect } from "react";
import { Button, Col, Dropdown, Form, Row } from "react-bootstrap";
import { Icon } from "@iconify/react";
import CommonRangeSlider from "./RangeSlider";
import { useParams } from "react-router-dom";
import { getFilters, getPriceRangeLimits } from "../api/ActivityService"; // ⬅️ Import new API
import TagSelector from "./TagSelector";

const FilterComponent = ({ onApplyFilters, onClearFilters, setPriceLimitsFromParent }) => {
  const [show, setShow] = useState(false);
  const [selectedSegment, setSelectedSegment] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedIndustries, setSelectedIndustries] = useState([]);
  const { category, slug } = useParams();

  const [segmentOptions, setSegmentOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [industriesOptions, setIndustriesOptions] = useState([]);

  const [priceRange, setPriceRange] = useState([10, 250]);
  const [priceLimits, setPriceLimits] = useState([10, 250]); // New state for dynamic min-max
  const handleToggle = (isOpen, event, metadata) => {
    // Optional: if you want to customize when it should close on click outside
    if (metadata?.source !== "select") {
      setShow(isOpen);
    }
  };
  const handleApply = () => {
    const applied = {
      segment: selectedSegment,
      categories: selectedCategories,
      industries: selectedIndustries,
      minPrice: priceRange[0],
      maxPrice: priceRange[1],
    };
    onApplyFilters(applied);
    handleToggle()
  };

  const handleClear = () => {
    setSelectedSegment("");
    setSelectedCategories([]);
    setSelectedIndustries([]);
    setPriceRange(priceLimits); // Reset to dynamic limits
    onClearFilters();
  };

  const handleCategoryChange = (id) => {
    setSelectedCategories((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const res = await getFilters(category);
        if (res.success) {
          setSegmentOptions(res.body.marketSegmentsListing || []);
          setCategoryOptions(res.body.category || []);
          setIndustriesOptions(res.body.industriesListing || []);
        }
      } catch (err) {
        console.error("Error fetching filters", err);
      }
    };

    const fetchPriceLimits = async () => {
      try {
        const res = await getPriceRangeLimits();
        if (res.success) {
          const { minPrice, maxPrice } = res.body;
          const safeMin = Math.max(minPrice, 0);
          const safeMax = Math.max(maxPrice, safeMin + 1); // Always keep min < max

          setPriceLimits([safeMin, safeMax]);
          setPriceRange([safeMin, safeMax]);
          setPriceLimitsFromParent([safeMin, safeMax]);
        }
      } catch (err) {
        console.error("Error fetching price limits", err);
      }
    };

    fetchFilters();
    fetchPriceLimits();
  }, [category]);
  useEffect(() => {
    const firstFetchFilters = async () => {
      try {
        const res = await getFilters(category, slug);
        if (res.success) {
          setSegmentOptions(res.body.marketSegmentsListing || []);
          setCategoryOptions(res.body.category || []);
          setIndustriesOptions(res.body.industriesListing || []);
          setSelectedCategories([res.body.selectedCat._id]);
        }
      } catch (err) {
        console.error("Error fetching filters", err);
      }
    }
    firstFetchFilters();
  }, []);
  // console.log('show', show)
  return (
    <Dropdown className="filterDropdown" align="end" show={show} onToggle={handleToggle}>
      <Dropdown.Toggle
       
        variant="light"
        className="d-flex align-items-center rounded-pill px-3"
        onClick={() => setShow((prev) => !prev)} // manual toggle
      >
        <Icon icon="mage:filter" fontSize={19} className="me-2" />
        <span className="iconFull">Filters</span>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Form>
          {/* Segments */}
          <Form.Label className="mb-2">
            <strong>Segments</strong>
          </Form.Label>
          <div className="radioFlex mb-3">
            {segmentOptions.map((segment, idx) => (
              <Form.Check
                key={idx}
                type="radio"
                id={`radio-${segment._id}`}
                name="segment"
                label={`${segment.title || segment.name} (${segment.count || "N/A"})`}
                checked={selectedSegment === segment._id}
                onChange={() => setSelectedSegment(segment._id)}
              />
            ))}
          </div>

          {/* Categories */}
          <Form.Label className="mb-2">
            <strong>Categories</strong>
          </Form.Label>
          <div className="radioFlex checkboxFlex mb-3 show-desktop">
        
            
     
             { categoryOptions.map((cat, idx) => (
                <Form.Check
                  key={idx}
                  type="checkbox"
                  id={`cat-${cat._id}`}
                  label={cat.title || cat.name}
                  checked={selectedCategories.includes(cat._id) || selectedCategories.includes(cat.slug)}
                  onChange={() => handleCategoryChange(cat._id)}
                />
              ))
}
          </div>

       <div className="adioFlex checkboxFlex mb-3 show-mobile">
       <TagSelector
                isMulti
                options={categoryOptions.map(cat => ({
                  value: cat._id,
                  label: cat.title || cat.name
                }))}
                value={categoryOptions
                  .filter(cat => selectedCategories.includes(cat._id) || selectedCategories.includes(cat.slug))
                  .map(cat => ({
                    value: cat._id,
                    label: cat.title || cat.name
                  }))}
                onChange={(selected) => {
                  const selectedIds = selected ? selected.map(option => option.value) : [];
                  setSelectedCategories(selectedIds);
                }}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Select categories..."
              />
       </div>

          {/* Industries */}
          <Form.Label className="mb-2">
            <strong>Industries</strong>
          </Form.Label>
          <div className="radioFlex checkboxFlex mb-3 show-desktop">
            {industriesOptions.map((industry, idx) => (
              <Form.Check
                key={idx}
                type="checkbox"
                id={`ind-${industry._id}`}
                label={industry.title || industry.name}
                checked={selectedIndustries.includes(industry._id)}
                onChange={() =>
                  setSelectedIndustries((prev) =>
                    prev.includes(industry._id)
                      ? prev.filter((id) => id !== industry._id)
                      : [...prev, industry._id]
                  )
                }
              />
            ))}
          </div>
          <div className="adioFlex checkboxFlex mb-3 show-mobile">
            <TagSelector
              isMulti
            
              options={industriesOptions.map(industry => ({
                value: industry._id,
                label: industry.title || industry.name  
              }))}
              value={industriesOptions
                .filter(industry => selectedIndustries.includes(industry._id))
                .map(industry => ({
                  value: industry._id,
                  label: industry.title || industry.name
                }))}
                onChange={(selected) => {
                  const selectedIds = selected ? selected.map(option => option.value) : [];
                  setSelectedIndustries(selectedIds);
                }}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Select industries..."
              />
            </div>
            
          {/* Pricing */}
          <Form.Label className="mb-2">
            <strong>Pricing</strong>
          </Form.Label>
          <CommonRangeSlider
            min={priceLimits[0]}
            max={priceLimits[1]}
            values={priceRange}
            onChange={setPriceRange}
            dollarSign={true}
          />

          <div className="mb-4 d-block" />
        </Form>

        <div className="filterButton">
          <Button
            className="border-radius-100"
            variant="danger-outline"
            onClick={handleClear}
          >
            Clear All Filters
          </Button>
          <Button
            className="border-radius-100"
            variant="info"
            onClick={handleApply}
          >
            Apply Filter
          </Button>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default FilterComponent;
